import DocumentStore from '@/frontapp/mixins/DocumentStore'

export default {
  mixins: [
    DocumentStore,
  ],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    showEditBtn () {
      return this.bcDocumentStore?.revisions.length && this.bcDocumentStore?.document.can_edit && !this.bcDocumentStore?.document.deleted
    },
  },
  methods: {
    async clickEditBtn() {
      this.loading = true
      // enter edit mode
      if (!this.bcDocumentStore.edit) {
        if (this.bcDocumentStore.documentRev === null) {
          // open latest revision of document
          await this.$router.replace({ 
            name: 'BCDocumentDetailRev',
            params: { revId: this.bcDocumentStore.revisions[0].id } 
          })
        }

        this.bcDocumentStore.edit = true
      } else { // leave edit mode
        if (this.bcDocumentStore.documentRev === this.bcDocumentStore.document.published__bc_document_rev_id) {
          // open latest revision of document
          await this.$router.replace({ 
            name: 'BCDocumentDetail',
            params: { revId: '' } 
          })
        }

        this.bcDocumentStore.edit = false
      } 
      this.loading = false
    }
  },
}